"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;

function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/utils/getDisplayName.js
// module id = 715
// module chunks = 0